var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSociety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.4 45",
    style: {
      enableBackground: "new 0 0 43.4 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#827F83;}\r\n\t.st1{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,0h-0.2c-2,0-3.6,0-4.9,0.2c-1.4,0.2-2.6,0.6-3.6,1.6c-1,1-1.4,2.2-1.6,3.6c-0.2,1.3-0.2,2.9-0.2,4.9 v0.2c-4.4,0.1-7,0.7-8.8,2.5c-1.5,1.5-2.1,3.5-2.4,6.7h43c-0.2-3.1-0.9-5.2-2.4-6.7C39,11,36.4,10.5,32,10.4v-0.2 c0-1.9,0-3.6-0.2-4.9c-0.2-1.4-0.6-2.6-1.6-3.6c-1-1-2.2-1.4-3.6-1.6C25.4,0,23.8,0,21.8,0z M28.7,10.3L28.7,10.3 c0-2.1,0-3.5-0.1-4.6c-0.1-1-0.4-1.4-0.6-1.7c-0.3-0.3-0.7-0.5-1.7-0.7c-1-0.1-2.5-0.1-4.5-0.1s-3.5,0-4.5,0.1 c-1,0.1-1.4,0.4-1.7,0.7s-0.5,0.7-0.6,1.7c-0.1,1.1-0.1,2.4-0.1,4.5H26C27,10.3,27.9,10.3,28.7,10.3L28.7,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,27.6c0-1.8,0-3.4,0-4.9h43.3c0,1.4,0,3.1,0,4.9s0,3.4,0,4.9H0C0,31.1,0,29.5,0,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,35.8c0.2,3.1,0.9,5.2,2.4,6.7C5.1,45,9.2,45,17.4,45H26c8.2,0,12.3,0,14.8-2.5c1.5-1.5,2.1-3.5,2.4-6.7 H0.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociety);
export default __webpack_public_path__ + "static/media/society.5caea58f9bdf86efbe4cafa3c086f078.svg";
export { ForwardRef as ReactComponent };